/* eslint-disable max-lines */
import webRoutes from '../../constants/screenRouteMapping/webRoutes';
import mobileScreens from '../../constants/screenRouteMapping/mobileScreens';
import screenKeys from '../../constants/screenRouteMapping/screenKeys';

export default {
  forgotPasswordMailRequestOtp: {
    url: '/forgot-password-mail',
    screenName: 'ForgotPasswordEmail'
  },
  forgotPasswordPhoneRequestOtp: {
    url: '/forgot-password-phone',
    screenName: 'ForgotPasswordPhone'
  },
  resetPassword: {
    url: '/reset-password',
    screenName: 'ResetPasswordScreen'
  },
  loginWithMail: {
    url: '/login',
    screenName: 'Login'
  },
  loginWithOTP: {
    url: '/login-through-otp',
    screenName: 'LoginWithOTPScreen'
  },
  privacyPolicy: {
    url: '/privacy-policy',
    screenName: 'PrivacyPolicyScreen'
  },
  termOfUse: {
    url: '/terms',
    screenName: 'TermOfUseScreen'
  },
  signUp: {
    url: '/propertyOnboard/sign_up',
    screenName: 'SignupScreen'
  },

  programImpactDetails: {
    url: '/hotel/:hotel_id/impactDetails/:pitch_id',
    screenName: 'OTABoostImpactDetailsScreen'
  },
  pitchCancel: {
    url: '/hotel/:hotel_id/impactDetails/:pitch_id/cancel',
    screenName: 'pitchDetailsCancelScreen'
  },
  pitchDetails: {
    url: '/hotel/:hotel_id/pitchDetails/:pitch_id',
    screenName: 'pitchDetailScreen'
  },
  dashboard: {
    url: '/hotel/:hotel_id/home',
    screenName: 'Home'
  },
  OTABoostSubscriptionSuccessScreen: {
    screenName: 'OTABoostSubscriptionSuccessScreen'
  },

  notFound: {
    url: '/404',
    screenName: 'DefaultScreen'
  },
  mobileOtpLogin: {
    url: '/propertyOnboard/sign_up',
    screenName: 'MobileOTPLogin'
  },
  instoreUrl: {
    url: '/hotel/:hotel_id/instore-conversion',
    screenName: 'InstoreConversionScreen'
  },
  incentiveManagement: {
    url: '/hotel/:hotel_id/incentive-management',
    screenName: 'Incentive'
  },
  incentivePitch: {
    url: '/hotel/:hotel_id/incentive-pitch/:pitch_id',
    screenName: 'IncentivePitchScreen'
  },
  pboiAgreement: {
    url: '/hotel/:hotel_id/bookings/requests/pboi',
    screenName: 'PboiAgreementScreen'
  },
  previewInvoice: {
    url: '/hotel/:hotel_id/bookings/requests/preview-invoice/:invoice_no',
    screenName: 'previewInvoice-dummy'
  },
  floorDropPitch: {
    url: '',
    screenName: 'FloorDropPitchScreen'
  },
  completedBookingDetailView: {
    url: '/hotel/:hotel_id/bookings/completed/:invoice_no/',
    screenName: 'completedBookingDetailView-dummy'
  },
  pricing_calendar_root: {
    url: '/hotel/:hotel_id/pricing_calendar',
    screenName: 'PricingCalendarRoot'
  },
  self_support: {
    url: '/hotel/:hotel_id/self-support',
    screenName: 'HelpSupportScreen'
  },
  pricing_insights: {
    url: '/hotel/:hotel_id/pricing-insights/',
    screenName: 'Pricing'
  },
  user_profile: {
    url: '/hotel/:hotel_id/profile',
    screenName: 'ProfileScreen'
  },
  business_reports: {
    url: '/hotel/:hotel_id/reports/business',
    screenName: 'BusinessReports'
  },
  daily_payout_details_screen: {
    url: '',
    screenName: 'DailyPayoutDetailsScreen'
  },
  restriction_screen: {
    url: '',
    screenName: 'Restrictions'
  },
  consolidated_booking_details_report_view: {
    url: '/hotel/:hotel_id/reports/consolidated-booking-details-report',
    screenName: 'consolidated_booking_details_report_view-dummy'
  },
  revenue_report_view: {
    url: '/hotel/:hotel_id/reports/revenue',
    screenName: 'revenue_report_view-dummy'
  },
  completed_bookings_screen: {
    url: '/hotel/:hotel_id/bookings/completed/',
    screenName: 'Bookings'
  },
  pricing_screen: {
    url: '/hotel/:hotel_id/pricing/',
    screenName: 'Pricing'
  },
  faq_with_contentId: {
    url: '/support-center/hotels/:hotel_id/faqs/:contentId',
    screenName: 'SupportCenterHome'
  },
  booking_detail: {
    url: '/hotel/:hotel_id/bookings/upcoming/:invoice_no/',
    screenName: 'BookingDetail'
  },
  secure_payments: {
    url: '/hotel/:hotel_id/secure_payments_screen',
    screenName: 'secure_payments_screen'
  },
  action_center: {
    url: '/hotel/:hotel_id/tasks',
    screenName: 'ActionCenter'
  },
  dashboardSupportScreen: {
    url: '',
    screenName: 'Home'
  },
  ticketDetailView: {
    url: '/support-center/hotels/:hotel_id/tickets/:ticket_id',
    screenName: 'TicketDetail'
  },
  createTicketView: {
    url: '/support-center/hotels/:hotel_id/new-ticket',
    screenName: 'CreateTicketView'
  },
  [screenKeys.SUPPORT_CENTER_HOME_PAGE]: {
    url: '/support-center/hotels/:hotel_id/home',
    screenName: 'HomeSupportCenter'
  },
  dashboardScreen: {
    url: '',
    screenName: 'Home'
  },
  ticketCreationSuccessScreen: {
    url: '/support-center/hotels/:hotel_id/new-ticket/:ticket_id/success',
    screenName: 'TicketCreationSuccessScreen'
  },
  myIssuesScreen: {
    url: '/support-center/hotels/:hotel_id/my-issues',
    screenName: ' MyIssuesScreen'
  },
  bookingIDSearchScreen: {
    url: '',
    screenName: 'TicketSearchScreen'
  },
  ticketCreationSuccessScreenModal: {
    url: '/support-center/hotels/:hotel_id/new-ticket/:ticket_id/modal_success',
    screenName: 'ticketCreationSuccessScreenModal-dummy'
  },
  supportCenter: {
    url: '',
    screenName: 'SupportCenterScreen'
  },
  supportCenterHome: {
    url: '/support-center/hotels/:hotel_id/faqs',
    screenName: 'HomeSupportCenter'
  },
  supportCenterContent: {
    isAuthorized: false,
    url: '/support-center/hotels/:hotel_id/faqs/:contentId',
    screenName: 'supportCenterContent-dummy'
  },
  preLiveSupportCenterContent: {
    url: '/support-center/faqs/:contentId',
    screenName: 'preLiveSupportCenterContent'
  },
  preLiveSupportCenterHome: {
    url: '/support-center/faqs',
    screenName: 'preLiveSupportCenterHome'
  },
  reconFinanceReport: {
    url: '/hotel/:hotel_id/finance_report/reconciliation-report',
    screenName: 'reconFinanceReport'
  },
  revenueFinanceReport: {
    url: '/hotel/:hotel_id/finance_report/revenue-finance-report',
    screenName: 'revenueFinanceReport'
  },
  paymentSplitFinanceReport: {
    url: '/hotel/:hotel_id/finance_report/payment-split-finance-report',
    screenName: 'paymentSplitFinanceReport'
  },
  successScreen: {
    url: '',
    screenName: 'DailyPayoutsSuccessScreen'
  },
  reconScreenV2: {
    url: '',
    screenName: 'ReconScreenV2'
  },
  dailyPayoutDetails: {
    url: '',
    screenName: 'DailyPayoutDetailsScreen'
  },
  dailyPayoutPitch: {
    screenName: 'DailyPayoutPitchScreen',
    url: ''
  },
  dailyPayoutTermsAndConditions: {
    screenName: 'DailyPayoutTnCScreen',
    url: ''
  },
  dailyPayoutCancel: {
    screenName: 'DailyPayoutCancellationScreen',
    url: ''
  },
  dailyPayoutFaq: {
    screenName: 'DailyPayoutFaqScreen',
    url: ''
  },
  pmAuthScreen: {
    url: '',
    screenName: 'PMAuthorisationScreen'
  },
  saas_pitch_screen: {
    url: '/hotel/:hotel_id/saas_pitch_screen/:program_id',
    screenName: 'SaasPitchScreen'
  },
  saas_manage_screen: {
    url: '/hotel/:hotel_id/saas_manage_screen/:program_id',
    screenName: 'SaasManageScreen'
  },
  saas_opt_out_screen: {
    url: '/hotel/:hotel_id/saas_opt_out_screen/:program_id',
    screenName: 'SaasOptOutScreen'
  },
  saas_opt_out_alternatives_screen: {
    url: '/hotel/:hotel_id/saas_opt_out_alternatives_screen/:program_id',
    screenName: 'SaasOptOutAlternativesScreen'
  },
  saas_opt_out_reason_alternatives_screen: {
    url: '/hotel/:hotel_id/saas_opt_out_reason_alternatives_screen/:program_id',
    screenName: 'SaasReasonBasedAlternativesScreen'
  },
  saas_opt_out_fomo_screen: {
    url: '/hotel/:hotel_id/saas_opt_out_fomo/:program_id',
    screenName: 'FomoScreen'
  },
  saas_opt_out_reasons_screen: {
    url: '/hotel/:hotel_id/saas_opt_out_reasons/:program_id',
    screenName: 'ReasonsScreen'
  },
  pitch_screen: {
    url: '/hotel/:hotel_id/pitch_screen/:feature_name/:campaign',
    screenName: 'SaasPitchScreen'
  },
  faq_widget_screen: {
    url: '/hotel/:hotel_id/faq_widget_screen/:feature_name/:campaign?',
    screenName: 'FAQWidgetScreen'
  },
  listingScreen: {
    url: '/hotel/:hotel_id/bookings/list',
    screenName: 'BookingListNew'
  },
  pendingCheckinScreen: {
    url: '/hotel/:hotel_id/bookings/list/pending-checkins',
    screenName: 'BookingPendingCheckinList'
  },
  pendingCheckoutScreen: {
    url: '/hotel/:hotel_id/bookings/list/pending-checkouts',
    screenName: 'BookingPendingCheckOutList'
  },
  calendarViewScreen: {
    url: '/hotel/:hotel_id/bookings/calendar-hotel',
    screenName: 'BookingCalendarRedesign'
  },
  newBookings: {
    url: '/hotel/:hotel_id/newbookings',
    screenName: 'newBookings-dummy'
  },
  booking_details_new: {
    url: '/hotel/:hotel_id/bookings/:invoice_no',
    screenName: 'NewBookingDetail'
  },
  pboi: {
    url: '/hotel/:hotel_id/pboi-requests/',
    screenName: 'NewBookingDetail'
  },
  all_opportunities_screen: {
    url: '/hotel/:hotel_id/all_opportunities_screen',
    screenName: 'AllOpportunitiesScreen'
  },
  revenue_hub_screen: {
    url: '/hotel/:hotel_id/growth_hub',
    screenName: 'RevenueHubScreen'
  },
  property_images: {
    url: '/hotel/:hotel_id/property/images',
    screenName: 'AddPropertyImages'
  },
  property_rooms: {
    url: '/hotel/:hotel_id/property/rooms',
    screenName: 'OnboardRoomAndCategoriesScreen'
  },
  property_general_info: {
    url: '/hotel/:hotel_id/property-details/property-info',
    screenName: 'PropertyDetails'
  },
  property_kyc: {
    url: '/hotel/:hotel_id/kyc-dashboard/',
    screenName: 'SelfOnboardL2KYCScreen'
  },
  generic_hub_screen: {
    url: '/hotel/:hotel_id/generic_hub/:module/:screenType',
    screenName: 'GenericHubScreen'
  },
  reward_status_screen: {
    url: '/hotel/:hotel_id/reward_status/:program_id',
    screen: 'RewardStatusScreen',
    screenName: 'RewardStatusScreen'
  },
  viewAllEarningInsight: {
    url: '/hotel/:hotel_id/earnings/insight',
    screenName: 'viewAllEarningIsight'
  },
  reconBreakDownScreen: {
    url: '/hotel/:hotel_id/recon-summary-details',
    screenName: 'ReconBreakDownScreen'
  },
  statementDetailScreen: {
    url: '/hotel/:hotel_id/statement-detail-screen',
    screenName: 'ReconStatementDetailScreen'
  },
  bookingRedirectionScreen: {
    url: '/hotel/:hotel_id/bookings/secure',
    screenName: 'BookingRedirectionScreen'
  },
  bookingSummaryScreen: {
    url: '/hotel/:hotel_id/bookings/:invoice_no/reconBookingDetails',
    screenName: 'ReconBookingDetails'
  },
  earningsInsightScreen: {
    url: '/hotel/:hotel_id/recon/earnings-insight',
    screenName: 'EarningsInsightScreen'
  },
  secureScreen: {
    url: '/hotel/:hotel_id/secure',
    screenName: 'SecureScreen'
  },
  secureWalletScreen: {
    url: '/hotel/:hotel_id/secure-wallet',
    screenName: 'SecureWalletScreen'
  },
  prepaidWalletScreen: {
    url: '/hotel/:hotel_id/prepaid-wallet',
    screenName: 'PrepaidWalletScreen'
  },
  reconfirmationScreen: {
    screenName: mobileScreens.RECONFIRMATION_PAGE
  },
  secureTransactionsScreen: {
    url: '/hotel/:hotel_id/secure/transactions',
    screenName: 'SecureTransactionsScreen'
  },
  ThreeCDashboard: {
    url: '',
    screenName: 'Hotel3CScreenV2'
  },
  threeCMetricDetails: {
    url: '',
    screenName: 'MetricDetailsContainer'
  },
  superOyoPitchScreen: {
    url: webRoutes.SUPER_OYO_PITCH_PAGE,
    screenName: mobileScreens.SUPER_OYO_PITCH_PAGE
  }
} as const;
